module.exports = "img {\n\theight: 80px;\n\tmargin: 30px 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/not-found/not-found.component.css
// module id = ./src/app/components/not-found/not-found.component.css
// module chunks = main